import { createFileRoute, redirect } from '@tanstack/react-router';

// `/settings` seul n'a pas d'écran propre : on ouvre l'onglet Entreprise.
export const Route = createFileRoute('/_app/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/organisation' });
  },
});
